import { render } from "./Genealogy.vue?vue&type=template&id=7388fffe"
import script from "./Genealogy.vue?vue&type=script&lang=js"
export * from "./Genealogy.vue?vue&type=script&lang=js"

import "./Genealogy.vue?vue&type=style&index=0&id=7388fffe&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__